import React from 'react';
import { Button, VStack, Text, Spinner, Tooltip, Icon } from '@chakra-ui/react';
import logo from '../../assets/img/logo/logo.png';
import SidebarCard from '../../components/sidebar/components/SidebarCard';

// chakra imports
import { Box, Flex, useColorModeValue } from '@chakra-ui/react';
import { MdEdit } from 'react-icons/md';

const Sidebar = ({ open, onClose, onSelectChat, onNewChat, chatHistoryList = [], currentChatId, loadingHistory }) => {
  // Color mode values - must be at component level
  const activeBg = useColorModeValue('blue.100', 'blue.900');
  const activeBorder = useColorModeValue('blue.200', 'whiteAlpha.200');
  const inactiveBorder = 'transparent';
  const inactiveBg = 'transparent';
  const hoverBg = useColorModeValue('gray.300', 'gray.700');
  const activeColor = useColorModeValue('blue.700', 'blue.300');
  const inactiveColor = useColorModeValue('gray.500', 'gray.500');
  const tooltipBg = useColorModeValue('gray.800', 'gray.200');
  const tooltipColor = useColorModeValue('white', 'gray.800');

  return (
    <>
      <Box
        position='fixed'
        minH='100%'
        className={`SidebarWrapper bg-lightPrimary dark:!bg-navy-900 flex min-h-full w-full flex-col border-r border-gray-200 transition-transform duration-300 ease-in-out ${open ? 'translate-x-0' : '-translate-x-full'}`}
        w='290px'
        zIndex='1000'
        // bg={useColorModeValue('white', 'gray.800')}
        borderColor={useColorModeValue('gray.200', 'gray.700')}
        color={useColorModeValue('gray.800', 'white')}
        boxShadow={useColorModeValue(
          '12px 0px 30px rgba(0, 0, 0, 0.13)',
          '20px 0px 40px rgba(0, 0, 0, 0.18)'
        )}
      >
        <Box h='100vh' display='flex' flexDirection='column'>
          {/* Header Section */}
          <Box p={4} borderBottom='1px' borderColor={useColorModeValue('gray.200', 'gray.700')}>
            <Flex align='center' mb={4}>
              <img src={logo} className='w-8 h-8' alt='logo' />
              <Text ml={3} fontSize='lg' fontWeight='semibold' color={useColorModeValue('gray.800', 'white')}>
                ValuePay.ai
              </Text>
            </Flex>

            {/* New Chat Button */}
            <Button
              width='full'
              variant='outline'
              color={useColorModeValue('gray.700', 'gray.300')}
              borderColor={useColorModeValue(activeBorder, activeBorder)}
              _hover={{
                bg: useColorModeValue(hoverBg, hoverBg),
                // borderColor: useColorModeValue(activeBorder, hoverBorder)
              }}
              onClick={onNewChat}
              leftIcon={<Text fontSize='sm'>✏️</Text>}
              fontSize='sm'
              py={2}
            >
              New chat
            </Button>
          </Box>

          {/* Chat History Section */}
          <Box flex='1' overflow='hidden' display='flex' flexDirection='column'>
            {/* Recent Heading */}
            <Box px={4} py={3}>
              <Text fontSize='sm' fontWeight='medium' color={useColorModeValue('gray.600', 'gray.400')}>
                Recent
              </Text>
            </Box>

            {/* Scrollable Chat List */}
            <Box flex='1' overflowY='auto' px={2}>
              {loadingHistory ? (
                <Flex align='center' justify='center' p={4}>
                  <Spinner size='sm' mr={2} />
                  <Text fontSize='sm' color='gray.500'>Loading chats...</Text>
                </Flex>
              ) : chatHistoryList.length === 0 ? (
                <Text fontSize='sm' color='gray.500' p={4} textAlign='center'>
                  No chats yet
                </Text>
              ) : (
                <VStack align='stretch' spacing={0}>
                  {chatHistoryList.map((chat, index) => (
                    <Box
                      className='relative'
                      key={chat.chatId}
                      pr={10}
                      pl={2}
                      py={1}
                      cursor='pointer'
                      borderRadius='md'
                      borderWidth='1px'
                      borderStyle='solid'
                      borderColor={chat.chatId === currentChatId ? activeBorder : inactiveBorder}
                      bg={chat.chatId === currentChatId ? activeBg : inactiveBg}
                      _hover={{
                        bg: chat.chatId === currentChatId ? activeBg : hoverBg
                      }}
                      onClick={() => onSelectChat(chat.chatId)}
                      transition='all 0.2s'
                    >
                      <Tooltip
                        label={chat.title || 'Untitled'}
                        placement='right'
                        hasArrow
                        bg={tooltipBg}
                        color={tooltipColor}
                        fontSize='sm'
                        maxW='300px'
                      >
                        <Text
                          fontSize='sm'
                          color={chat.chatId === currentChatId ? activeColor : inactiveColor}
                          noOfLines={1}
                          overflow='hidden'
                          textOverflow='ellipsis'
                          whiteSpace='nowrap'
                          px={2}
                          py={2}
                          cursor='pointer'
                        >
                          {chat.title || 'Untitled'}
                        </Text>
                      </Tooltip>

                      <Icon
                        className='absolute right-2 top-3'
                        color={chat.chatId === currentChatId ? activeColor : inactiveColor}
                        cursor="not-allowed"
                        as={MdEdit}
                        ms="auto"
                        width="16px"
                        height="16px"
                      />
                    </Box>
                  ))}
                </VStack>
              )}
            </Box>
          </Box>

          {/* Footer */}
          <Box p={4} borderTop='1px' borderColor={useColorModeValue('gray.200', 'gray.700')}>
            <SidebarCard />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Sidebar;
